import React from 'react';
import MobileHeader from "components/mobile-header";
import PageHeader from "components/page-header";
import NotificationBar from 'components/notification-bar';
import TemplatesSidebar from 'components/template-preview';


const Templates = () => {

    return (
    <div className="w-full px-4 md:px-6 lg:px-6">
      <MobileHeader />
      
      <PageHeader label="Templates">
        <NotificationBar />
      </PageHeader>
      

      <TemplatesSidebar />
    </div>
  );
};

export default Templates;